import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mt-5" }
const _hoisted_2 = { class: "flex flex-nowrap justify-between gap-10 w-full" }
const _hoisted_3 = { class: "relative z-0 flex flex-nowrap w-full" }
const _hoisted_4 = { class: "static z-0 w-32 ml-2 bg-[linear-gradient(180deg,#43e11b,#08690b,86%,#fff815)]! rounded-lg inset-shadow-xs" }
const _hoisted_5 = { class: "block w-24 text-white text-[12px] font-semibold py-1 text-start ml-auto cursor-default" }
const _hoisted_6 = { class: "relative z-0 flex flex-nowrap w-full flex-row-reverse" }
const _hoisted_7 = { class: "static z-0 w-32 mr-2 bg-[linear-gradient(180deg,#43e11b,#08690b,86%,#fff815)]! rounded-lg inset-shadow-xs" }
const _hoisted_8 = { class: "block w-24 text-white text-[12px] font-semibold py-1 text-end mr-auto cursor-default" }
const _hoisted_9 = { class: "grid grid-cols-2 gap-5 w-full mt-5" }
const _hoisted_10 = { class: "flex flex-col gap-3 items-center justify-center w-full" }
const _hoisted_11 = { class: "relative z-0" }
const _hoisted_12 = { class: "relative z-0 top-0" }
const _hoisted_13 = { class: "absolute z-10 -bottom-8 left-1/2 -translate-x-1/2" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "text-sm text-white font-extrabold" }
const _hoisted_16 = { class: "flex justify-between w-full mx-2" }
const _hoisted_17 = { class: "text-[10px] text-white font-bold w-full" }
const _hoisted_18 = { class: "text-[10px] text-white font-bold w-full" }
const _hoisted_19 = { class: "flex justify-between items-center w-full" }
const _hoisted_20 = { class: "flex items-center gap-1.5" }
const _hoisted_21 = { class: "text-sm text-white select-all" }
const _hoisted_22 = {
  key: 0,
  class: "flex justify-between w-full"
}
const _hoisted_23 = { class: "text-sm text-white" }
const _hoisted_24 = { class: "flex justify-between items-center w-full" }
const _hoisted_25 = {
  key: 0,
  class: "flex items-center gap-1.5"
}
const _hoisted_26 = { class: "text-sm text-white select-all" }
const _hoisted_27 = { class: "flex justify-between items-center w-full" }
const _hoisted_28 = {
  key: 0,
  class: "flex items-center gap-1.5"
}
const _hoisted_29 = { class: "text-sm text-white select-all" }
const _hoisted_30 = {
  key: 0,
  class: "flex justify-between w-full"
}
const _hoisted_31 = { class: "text-sm text-white" }
const _hoisted_32 = { class: "grid grid-cols-2 gap-2 w-full mt-5" }

export function render(_ctx, _cache) {
  const _component_PopupMainNavbar = _resolveComponent("PopupMainNavbar")
  const _component_Knob = _resolveComponent("Knob")
  const _component_CopyButton = _resolveComponent("CopyButton")
  const _component_Card = _resolveComponent("Card")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PopupMainNavbar),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "absolute z-10 left-0 bottom-1/2 translate-y-1/2 bg-[#ad920d]! border border-white flex justify-center items-center size-8 rounded-full" }, [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              "stroke-width": "1.5",
              stroke: "currentColor",
              class: "size-6 text-white"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d: "M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              })
            ])
          ], -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.formatCurrency(_ctx.profile?.balance || 0)), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "absolute z-10 right-0 bottom-1/2 translate-y-1/2 bg-[#ad920d]! border border-white flex justify-center items-center size-8 rounded-full" }, [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              "stroke-width": "1.5",
              stroke: "currentColor",
              class: "size-6 text-white"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d: "M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
              })
            ])
          ], -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.profile?.walletDiamond), 1 /* TEXT */)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-full" }, [
          _createElementVNode("object", {
            class: "rounded-lg pointer-events-none",
            data: "https://tos168.sgp1.cdn.digitaloceanspaces.com/profile.svg",
            type: "image/svg+xml"
          })
        ], -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Knob, {
                "model-value": _ctx.knobValue,
                max: _ctx.knobMax,
                readonly: "",
                class: "w-full",
                pt: {svg:'w-full'}
              }, null, 8 /* PROPS */, ["model-value", "max"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("img", {
                src: _ctx.profile?.rank.imageRank,
                alt: _ctx.profile?.rank.rank,
                class: "size-20 mx-auto"
              }, null, 8 /* PROPS */, _hoisted_14)
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.profile?.rank.rank), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, "LEVEL: " + _toDisplayString(_ctx.profile?.rank.level), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_18, "SEASON: " + _toDisplayString(_ctx.profile?.rank.season), 1 /* TEXT */)
          ])
        ])
      ]),
      _createCommentVNode(" ข้อมูลจาก profile "),
      _createVNode(_component_Card, {
        class: "mt-3 md:mt-5",
        pt: {root: 'overflow-hidden! bg-transparent! bg-[linear-gradient(180deg,#2d2d2dba,#281401ba)]! border! border-[#d5be6e]!'}
      }, {
        content: _withCtx(() => [
          _createElementVNode("p", _hoisted_19, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-sm text-white font-bold" }, "บัญชีผู้ใช้", -1 /* HOISTED */)),
            _createElementVNode("span", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.profile?.username || '-'), 1 /* TEXT */),
              (_ctx.profile?.username)
                ? (_openBlock(), _createBlock(_component_CopyButton, {
                    key: 0,
                    value: _ctx.profile?.username,
                    label: "บัญชีผู้ใช้",
                    "icon-class": "size-5 text-white"
                  }, null, 8 /* PROPS */, ["value"]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          (_ctx.isBankUpdated)
            ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-sm text-white font-bold" }, "ชื่อ", -1 /* HOISTED */)),
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.profile?.firstName) + " " + _toDisplayString(_ctx.profile?.lastName), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Card, {
        class: "mt-3 md:mt-5",
        pt: {root: 'overflow-hidden! bg-transparent! bg-[linear-gradient(180deg,#2d2d2dba,#281401ba)]! border! border-[#d5be6e]!'}
      }, {
        content: _withCtx(() => [
          _createElementVNode("p", _hoisted_24, [
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-sm text-white font-bold" }, "P2P ID", -1 /* HOISTED */)),
            (_ctx.isP2PUpdated)
              ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.profile?.peer2PayUID), 1 /* TEXT */),
                  _createVNode(_component_CopyButton, {
                    value: _ctx.profile?.peer2PayUID,
                    label: "P2P ID",
                    "icon-class": "size-5 text-white"
                  }, null, 8 /* PROPS */, ["value"])
                ]))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  onClick: _ctx.btnClickUpdateP2p,
                  label: "อัปเดต P2P UID",
                  variant: "text",
                  size: "small",
                  class: "text-xs! text-[#16f766]! py-1!"
                }, null, 8 /* PROPS */, ["onClick"]))
          ])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Card, {
        class: "mt-3 md:mt-5",
        pt: {root: 'overflow-hidden! bg-transparent! bg-[linear-gradient(180deg,#2d2d2dba,#281401ba)]! border! border-[#d5be6e]!'}
      }, {
        content: _withCtx(() => [
          _createElementVNode("p", _hoisted_27, [
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-sm text-white font-bold" }, "เลขบัญชี", -1 /* HOISTED */)),
            (_ctx.isBankUpdated)
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.profile?.customerBankAccount), 1 /* TEXT */),
                  _createVNode(_component_CopyButton, {
                    value: _ctx.profile?.customerBankAccount,
                    label: "เลขบัญชี",
                    "icon-class": "size-5 text-white"
                  }, null, 8 /* PROPS */, ["value"])
                ]))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  onClick: _ctx.btnClickUpdateBank,
                  label: "อัปเดตบัญชี",
                  variant: "text",
                  size: "small",
                  class: "text-xs! text-[#16f766]! py-1!"
                }, null, 8 /* PROPS */, ["onClick"]))
          ]),
          (_ctx.isBankUpdated)
            ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-sm text-white font-bold" }, "ธนาคาร", -1 /* HOISTED */)),
                _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.profile?.customerBankName), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_32, [
        _createVNode(_component_Button, {
          onClick: _ctx.btnClickChangePassword,
          class: "bg-transparent! p-0! border-0!"
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createElementVNode("img", {
              src: "https://168tos.sgp1.cdn.digitaloceanspaces.com/theme/b-1.webp",
              alt: "",
              class: "w-full"
            }, null, -1 /* HOISTED */)
          ])),
          _: 1 /* STABLE */,
          __: [8]
        }, 8 /* PROPS */, ["onClick"]),
        _createVNode(_component_Button, {
          onClick: _ctx.btnClickWalletDepositAuto,
          class: "bg-transparent! p-0! border-0!"
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createElementVNode("img", {
              src: "https://168tos.sgp1.cdn.digitaloceanspaces.com/theme/b-2.webp",
              alt: "",
              class: "w-full"
            }, null, -1 /* HOISTED */)
          ])),
          _: 1 /* STABLE */,
          __: [9]
        }, 8 /* PROPS */, ["onClick"]),
        _createVNode(_component_Button, {
          onClick: _ctx.btnClickEntertainment,
          class: "bg-transparent! p-0! border-0!"
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createElementVNode("img", {
              src: "https://168tos.sgp1.cdn.digitaloceanspaces.com/theme/b-3.webp",
              alt: "",
              class: "w-full"
            }, null, -1 /* HOISTED */)
          ])),
          _: 1 /* STABLE */,
          __: [10]
        }, 8 /* PROPS */, ["onClick"]),
        _createVNode(_component_Button, {
          onClick: _ctx.btnClickPromotionList,
          class: "bg-transparent! p-0! border-0!"
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createElementVNode("img", {
              src: "https://168tos.sgp1.cdn.digitaloceanspaces.com/theme/b-4.webp",
              alt: "",
              class: "w-full"
            }, null, -1 /* HOISTED */)
          ])),
          _: 1 /* STABLE */,
          __: [11]
        }, 8 /* PROPS */, ["onClick"])
      ])
    ])
  ]))
}